var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "700px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 1,
              expression: "step===1"
            }
          ]
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": "100px",
                "label-position": "left",
                inline: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyCode") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.code,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "code", $$v)
                      },
                      expression: "tenantForm.code"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyName") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "name", $$v)
                      },
                      expression: "tenantForm.name"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyEMail") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "email", $$v)
                      },
                      expression: "tenantForm.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyPhone") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "phone", $$v)
                      },
                      expression: "tenantForm.phone"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyFax") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.fax,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "fax", $$v)
                      },
                      expression: "tenantForm.fax"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.GroupCompany") } },
                [
                  _c("el-checkbox", {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.tenantForm.groupCompany,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "groupCompany", $$v)
                      },
                      expression: "tenantForm.groupCompany"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Menu.CompanyAddress") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { type: "textarea", rows: 3 },
                    model: {
                      value: _vm.tenantForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.tenantForm, "address", $$v)
                      },
                      expression: "tenantForm.address"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _vm.isShowAdmin
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Menu.AdminChineseName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: !_vm.userNameEnabled },
                        model: {
                          value: _vm.tenantForm.userName,
                          callback: function($$v) {
                            _vm.$set(_vm.tenantForm, "userName", $$v)
                          },
                          expression: "tenantForm.userName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isShowAdmin
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Menu.AdminEnglishName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: !_vm.userEngligshNameEnabled },
                        model: {
                          value: _vm.tenantForm.userEngligshName,
                          callback: function($$v) {
                            _vm.$set(_vm.tenantForm, "userEngligshName", $$v)
                          },
                          expression: "tenantForm.userEngligshName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isShowAdmin
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Menu.email") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: !_vm.userEmailEnabled },
                        model: {
                          value: _vm.tenantForm.userEmail,
                          callback: function($$v) {
                            _vm.$set(_vm.tenantForm, "userEmail", $$v)
                          },
                          expression: "tenantForm.userEmail"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isShowAdmin
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Menu.phone") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: !_vm.userPhoneEnabled },
                        model: {
                          value: _vm.tenantForm.userPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.tenantForm, "userPhone", $$v)
                          },
                          expression: "tenantForm.userPhone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 2,
              expression: "step===2"
            }
          ],
          staticStyle: { height: "200px" }
        },
        [
          _c(
            "el-form",
            [
              _c("br"),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("el-form-item", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-size": "20px", color: "red" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Menu.Current")) +
                        " : " +
                        _vm._s(_vm.tenantForm.id)
                    )
                  ]
                )
              ]),
              _c("center", [
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Menu.StandardLibrary")))
                        ]),
                        _c("cargo-advance-select", {
                          ref: "tenantSel",
                          staticStyle: {
                            width: "200px",
                            display: "inline-block",
                            "margin-left": "10px"
                          },
                          attrs: {
                            "select-type": _vm.selectTypeNames.TENANT,
                            cache: false,
                            filterable: "",
                            "custom-label": _vm.companyLabel,
                            "callback-params": { key: "relateTenantId" },
                            "callback-method-type": "value",
                            "default-value": _vm.cboTenantId
                              ? _vm.cboTenantId
                              : "",
                            "static-options": _vm.standardList
                          },
                          on: { parentCallBack: _vm.tenantIdChangeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 3,
              expression: "step===3"
            }
          ]
        },
        [_c("init-data-group", { attrs: { obj: _vm.initDatagroupObj } })],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 4,
              expression: "step===4"
            }
          ],
          staticClass: "section grid-wrapper"
        },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.menus
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step !== 1,
                  expression: "step!==1"
                }
              ],
              attrs: { type: "primary" },
              on: { click: _vm.backStep1Handler }
            },
            [_vm._v(_vm._s(_vm.$t("Menu.Back")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveClickHandler } },
            [
              _vm._v(
                _vm._s(
                  _vm.isShowAdmin ? _vm.$t("Menu.Next") : _vm.$t("Menu.Save")
                )
              )
            ]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("Menu.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }